<template>
  <div class="ProfileUpdate">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="profile-update-container">
      <div class="form-section">
        <div class="text-center">
          <div class="font-weight-600" style="font-size: 1.2rem">Welcome to StockAnts!</div>

          <div class="top-margin-10 font-09rem">
            You are just few steps away from
            {{ profession == 'Retail Investor' ? 'using StockAnts.' : 'building your track record.' }}
          </div>
          <div class="font-09rem">Complete the profile and get started.</div>
        </div>

        <div class="flex" style="margin-top: 50px">
          <div style="width: 50%; margin-right: 15px" :style="[profession == 'Market Expert' || profession == 'Retail Investor' ? { width: '100%' } : { width: '50%' }]">
            <div class="flex input-label bottom-margin-5">
              <div class="bullets" v-if="basicProfileProgress < 100" :style="[active_step == 1 ? { background: '#e72726' } : { background: '#cbcbcb' }]">1</div>

              <i class="el-icon-success" v-if="basicProfileProgress == 100" style="font-size: 15px" :style="[basicProfileProgress == 100 ? { color: '#e72726' } : { color: '#cbcbcb' }]"></i>

              &nbsp; Basic details
            </div>

            <el-progress :percentage="basicProfileProgress" :show-text="false" :color="active_step == 1 || basicProfileProgress == 100 ? '#e72726' : '#cbcbcb'"></el-progress>
          </div>

          <div style="width: 50%; margin-right: 15px" v-if="profession != 'Market Expert' && profession != 'Retail Investor'">
            <div class="flex input-label bottom-margin-5">
              <div class="bullets" v-if="kycDocProgress < 100" :style="[active_step == 2 ? { background: '#e72726' } : { background: '#cbcbcb' }]">2</div>

              <i class="el-icon-success" v-if="kycDocProgress == 100" style="font-size: 15px" :style="[kycDocProgress == 100 ? { color: '#e72726' } : { color: '#cbcbcb' }]"></i>

              &nbsp; eKYC
            </div>

            <el-progress :percentage="kycDocProgress" :show-text="false" :color="active_step == 2 || kycDocProgress == 100 ? '#e72726' : '#cbcbcb'"></el-progress>
          </div>
        </div>

        <el-card class="box-card form top-margin-25" v-loading="is_profile_save_loading">
          <div class="text-right bottom-margin-20" v-if="userProfile.profession != 'Retail Investor'">
            <u class="external-link-color cursor-pointer font-08rem" @click="goToExpertStore()">Preview</u>
          </div>

          <div v-if="active_step == 1">
            <el-row class="top-margin-25" :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- Profile Image Section -->
                <div class="profile-pic-upload-section">
                  <label class="input-label block bottom-margin-5 text-center">Profile Picture</label>
                  <img :src="profile_pic" id="profile" class="profile-pic-upload" />
                  <div class="profile-pic-loader" v-if="is_profile_pic_loading">
                    <i class="el-icon-loading"></i>
                  </div>
                  <label class="select-file cursor-pointer" for="file-input">
                    <input id="file-input" type="file" style="display: none" ref="file" accept="image/png, image/jpeg" @change="handleFileUpload('profile')" />
                  </label>
                </div>
              </el-col>
            </el-row>

            <el-row class="top-margin-25" :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': full_name.length,
                    'form-group--error': show_error_on_empty && $v.full_name.$error,
                  }"
                >
                  <label class="input-label bottom-margin-5">Full Name</label>
                  &nbsp;
                  <span class="required-field">*</span>

                  <el-input type="text" v-model="full_name" placeholder="Full name" size="small" @input="setFirstname($event)"></el-input>
                </div>

                <div style="color: red; font-size: 0.75em" v-if="validate_full_name">Please enter alphabetic characters only</div>

                <div class="error" v-if="show_error_on_empty && !$v.full_name.required">Field is required</div>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': email.length,
                    'form-group--error': show_error_on_empty && $v.email.$error,
                  }"
                >
                  <label class="input-label bottom-margin-5">Email</label>
                  &nbsp;
                  <span class="required-field">*</span>

                  <div class="flex">
                    <el-input type="email" v-model="email" placeholder="Email" size="small" @input="setEmail($event)" :disabled="is_email_verified"></el-input>

                    <span class="font-07rem font-weight-500 flex left-margin-10 cursor-pointer" style="color: #d60918" @click="sendOTPForEmailVerification()" v-if="!is_email_verified">Verify</span>

                    <span class="font-07rem font-weight-500 flex left-margin-10" style="color: #079e3e" v-if="is_email_verified">Verified</span>
                  </div>
                </div>

                <div style="color: red; font-size: 0.75em" v-if="validate_email_id">Enter valid Email id</div>

                <div class="error" v-if="show_error_on_empty && !$v.email.required">Field is required</div>
              </el-col>
            </el-row>

            <el-row class="top-margin-15" :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': mobile.length,
                    'form-group--error': show_error_on_empty && $v.mobile.$error,
                  }"
                >
                  <label class="input-label bottom-margin-5">Phone</label>
                  &nbsp;
                  <span class="required-field">*</span>
                  <div class="flex">
                    <!-- Country Code Dropdown -->
                    <el-select 
  v-model="selectedCountryCode" 
  placeholder="Code" 
  size="small" 
  style="width: 170px" 
  filterable 
  :disabled="is_mobile_verified"
  :popper-class="'dropdown-with-search'"
>
  <template #prefix>
    <span v-if="selectedCountry">
      <img :src="selectedCountry.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 5px; padding-top:8px; vertical-align: middle;" />
    </span>
  </template>
  
  <el-option
    v-for="country in countryCodes"
    :key="`${country.country_code}-${country.name}`" 
    :label="`${country.country_code}`" 
    :value="country.country_code"
  >
    <span class="custom-label" style="display: flex; align-items: center">
      <img :src="country.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 8px; vertical-align: middle" />
      <span style="margin-right: 8px">{{ country.country_code }}</span>
      {{ country.name }}
    </span>
  </el-option>
</el-select>

                    <!-- Mobile Input -->
                    <el-input type="phone" v-model="mobile" :maxlength="getMaxLength()" placeholder="Mobile no" size="small" @input="validateMobileNumber" :disabled="is_mobile_verified" style="margin-left:5px"></el-input>

                    <!-- Verify or Verified Button -->
                    <span class="font-07rem font-weight-500 flex left-margin-10 cursor-pointer" style="color: #d60918" @click="sendOTPForMobileVerification" v-if="!is_mobile_verified">Verify</span>

                    <span class="font-07rem font-weight-500 flex left-margin-10" style="color: #079e3e" v-if="is_mobile_verified">Verified</span>
                  </div>
                </div>

                <!-- Validation Messages -->
                <div style="color: red; font-size: 0.75em" v-if="mo_no_validation">Mobile no. must be numeric and exactly {{ getMaxLength() }} digits for the selected country code.</div>
                <div class="error" v-if="show_error_on_empty && !$v.mobile.required">Field is required</div>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': profession.length,
                    'form-group--error': show_error_on_empty && $v.profession.$error,
                  }"
                >
                  <label class="input-label bottom-margin-5">Profession</label>
                  &nbsp;
                  <span class="required-field">*</span>

                  <el-select v-model="profession" placeholder="Profession" style="width: 100%" size="small" @change="setProfession(profession)" :disabled="profession == 'Retail Investor' || profession == 'Dealer'">
                    <el-option v-for="item in profession_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>

                <div class="error" v-if="show_error_on_empty && !$v.profession.required">Field is required</div>
              </el-col>
            </el-row>

            <el-row class="top-margin-15" :gutter="10" v-if="profession != 'Student' && profession != 'Retail Investor' && profession != 'Dealer'">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': company.length,
                    'form-group--error': show_error_on_empty && $v.company.$error && profession == 'Broker',
                  }"
                >
                  <label class="input-label bottom-margin-5">Company Name</label>
                  &nbsp;
                  <span class="required-field" v-if="profession == 'Broker'">*</span>

                  <el-input type="text" placeholder="Company Name" v-model="company" size="small" @input="setCompanyName($event)" :disabled="profession == 'Retail Investor'"></el-input>
                </div>

                <div class="error" v-if="show_error_on_empty && !$v.company.required">Field is required</div>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="profession != 'Retail Investor'">
                <label class="input-label">Website</label>

                <div>
                  <el-input placeholder="E.g. www.stockants.com" size="small" v-model="website"></el-input>
                </div>
              </el-col>
            </el-row>

            <!-- <el-row class="top-margin-15" :gutter="10" v-if="shouldShowDetails">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="pan_card_number != null">
                <label class="input-label">Pan Card Number</label>

                <el-input placeholder="Pan Card Number" size="small" v-model="pan_card_number" disabled></el-input>
              </el-col>
            </el-row> -->

            <el-row class="top-margin-15" :gutter="10" v-if="profession != 'Retail Investor' && profession != 'Dealer'">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <label class="input-label">About Company</label>

                <div>
                  <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4 }" resize="none" show-word-limit v-model="about"></el-input>
                </div>
              </el-col>
            </el-row>

            <div v-if="profession == 'Dealer'">
              <el-row class="bottom-margin-10" :gutter="10">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <div
                    class="form-group"
                    :class="{
                      'not-empty': selectedBrokers.length,
                      'form-group--error': show_error_on_empty && $v.selectedBrokers.$error,
                    }"
                  >
                    <label class="input-label bottom-margin-5">Broker Name</label>
                    &nbsp;
                    <span class="required-field">*</span>

                    <el-select v-model="selectedBrokers" placeholder="Broker Name" style="width: 100%" size="small" multiple @change="setBrokerName(selectedBrokers)">
                      <el-option v-for="item in broker_list" :key="item.value" :label="item.Title" :value="item.Id"></el-option>
                    </el-select>
                  </div>

                  <div class="error" v-if="show_error_on_empty && !$v.selectedBrokers.required">Field is required</div>
                </el-col>

                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <div
                    class="form-group"
                    :class="{
                      'not-empty': dealer_registration_number.length,
                      'form-group--error': show_error_on_empty && $v.dealer_registration_number.$error,
                    }"
                  >
                    <label class="input-label bottom-margin-5">Registration Number</label>
                    &nbsp;
                    <span class="required-field">*</span>
                    <div class="flex">
                      <el-input type="number" v-model="dealer_registration_number" placeholder="Registration Number" size="small" @input="setBrokerRegistrationNumber($event)"></el-input>
                    </div>
                  </div>

                  <div class="error" v-if="show_error_on_empty && !$v.dealer_registration_number.required">Field is required</div>
                </el-col>
              </el-row>

              <div class="bottom-margin-15">
                <label class="input-label bottom-margin-5">
                  Are you SEBI registered?
                  <!-- <span class="required-field" v-if='isSebiUser'>*</span> -->
                </label>
                <!-- <div class="flex"> -->
                <el-row class="top-margin-5 flex" :gutter="10">
                  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <el-radio v-model="isSebiUser" :label="true" style="margin-right: 20px">Yes</el-radio>
                    <el-radio v-model="isSebiUser" :label="false">No</el-radio>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="isSebiUser">
                    <el-input type="number" v-model="sebi_registration_number" maxlength="10" placeholder="SEBI Registration Number" size="small"></el-input>
                  </el-col>
                  <!-- </div> -->
                </el-row>
              </div>
            </div>

            <div class="top-margin-25" style="border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; padding: 20px 0" v-if="profession != 'Retail Investor' && profession != 'Dealer'">
              <div class="font-08rem font-weight-600 label-color">Social Media Accounts</div>

              <el-row class="top-margin-20" :gutter="10">
                <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                  <div class="text-center bottom-margin-15">
                    <div class="flex-center">
                      <img src="../assets/images/profile/gmail.png" width="30" />
                      <span class="left-margin-10 title">Gmail</span>
                    </div>

                    <input type="text" placeholder="Enter your email id" class="social-media-inputs" v-model="gmail_link" />
                  </div>
                </el-col>

                <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                  <div class="text-center bottom-margin-15">
                    <div class="flex-center">
                      <img src="../assets/images/profile/facebook.png" width="30" />
                      <span class="left-margin-10 title">Facebook</span>
                    </div>

                    <input type="text" placeholder="Enter page link" class="social-media-inputs" v-model="facebook_link" />
                  </div>
                </el-col>

                <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                  <div class="text-center bottom-margin-15">
                    <div class="flex-center">
                      <img src="../assets/images/profile/linkedin.png" width="30" />
                      <span class="left-margin-10 title">Linked in</span>
                    </div>

                    <input type="text" placeholder="Enter page link" class="social-media-inputs" v-model="linkedin_link" />
                  </div>
                </el-col>
              </el-row>

              <el-row class="top-margin-15">
                <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                  <div class="text-center bottom-margin-15">
                    <div class="flex-center">
                      <img src="../assets/images/profile/telegram.png" width="30" />
                      <span class="left-margin-10 title">Telegram</span>
                    </div>

                    <input type="text" placeholder="Enter channel name" class="social-media-inputs" v-model="telegram_link" />
                  </div>
                </el-col>

                <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                  <div class="text-center bottom-margin-15">
                    <div class="flex-center">
                      <img src="../assets/images/Youtube Icon.png" width="30" style="cursor: pointer" />
                      <span class="left-margin-10 title">Youtube</span>
                    </div>

                    <input type="text" placeholder="Enter page link" class="social-media-inputs" v-model="youtube_link" />
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="top-margin-15 text-right" v-if="profession == 'Retail Investor' || profession == 'Market Expert'">
              <el-button class="btn-theme-borderd" size="small" @click="goToNextStep(2)">FINISH</el-button>
            </div>
            <div class="top-margin-15 text-right" v-else>
              <el-button class="btn-theme-borderd" size="small" @click="goToNextStep(2)">NEXT</el-button>
            </div>
          </div>

          <div v-if="active_step == 2" style="padding: 0 20px">
            <div class="flex font-07rem top-margin-10" style="border-radius: 10px; background: #f5f5f5; color: #878787; font-weight: 500; padding: 10px; justify-content: center">
              <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" style="height: 14px; margin-right: 5px" />

              Please fill the following details to get the verified blue tick on your profile.
            </div>

            <div class="top-margin-15" v-if="profession == 'Dealer'">
              <label class="input-label bottom-margin-5">NISM Certificate</label>

              <div class="green-box" v-if="!is_nism_uploaded || is_nism_uploaded == 'REJECTED'" @click="openNISMInput()">
                <input type="file" ref="nism_certificate" style="display: none" @change="getNISMFile($event)" />

                <span><i class="el-icon-paperclip cursor-pointer" v-if="!is_nism_uploaded && !nism_file">&nbsp;Upload NISM Certificate</i></span>

                <span><i class="el-icon-error cursor-pointer" v-if="is_nism_uploaded == 'REJECTED'">&nbsp;Rejected</i></span>

                <span><i class="el-icon-success" v-if="nism_file">&nbsp;Selected</i></span>
              </div>

              <div v-if="is_nism_uploaded == 'APPROVED' || is_nism_uploaded == 'UPLOADED'" class="green-box">
                <span><i class="el-icon-success" v-if="is_nism_uploaded == 'APPROVED'">&nbsp;Approved</i></span>
                <span><i class="el-icon-success" v-if="is_nism_uploaded == 'UPLOADED'">&nbsp;Uploaded</i></span>
              </div>
            </div>

            <div class="top-margin-15">
              <label class="input-label bottom-margin-5">SEBI Certificate</label>

              <div v-if="!is_sebi_certificate_uploaded || is_sebi_certificate_uploaded == 'REJECTED'" class="blue-box" @click="openSEBICertificateInput()">
                <input type="file" ref="sebi_certificate" style="display: none" @change="getSEBIFile($event)" />

                <span><i class="el-icon-paperclip cursor-pointer" v-if="!is_sebi_certificate_uploaded && !sebi_certificate_file">&nbsp;Upload Certificate</i></span>

                <span><i class="el-icon-error cursor-pointer" v-if="is_sebi_certificate_uploaded == 'REJECTED'">&nbsp;Rejected</i></span>

                <span><i class="el-icon-success" v-if="sebi_certificate_file">&nbsp;Selected</i></span>
              </div>

              <div v-if="is_sebi_certificate_uploaded == 'APPROVED' || is_sebi_certificate_uploaded == 'UPLOADED'" class="green-box">
                <span><i class="el-icon-success" v-if="is_sebi_certificate_uploaded == 'APPROVED'">&nbsp;Approved</i></span>
                <span><i class="el-icon-success" v-if="is_sebi_certificate_uploaded == 'UPLOADED'">&nbsp;Uploaded</i></span>
              </div>
            </div>

            <div class="top-margin-15">
              <label class="input-label bottom-margin-5">PAN Card</label>

              <div class="green-box" v-if="!is_pan_card_uploaded || is_pan_card_uploaded == 'REJECTED'" @click="openPANCardInput($event)">
                <input type="file" ref="pan_card" style="display: none" @change="getPANFile($event)" />

                <span><i class="el-icon-paperclip cursor-pointer" v-if="!is_pan_card_uploaded && !pan_card_file">&nbsp;Upload PAN Card</i></span>

                <span><i class="el-icon-error cursor-pointer" v-if="is_pan_card_uploaded == 'REJECTED'">&nbsp;Rejected</i></span>

                <span><i class="el-icon-success" v-if="pan_card_file">&nbsp;Selected</i></span>
              </div>

              <div v-if="is_pan_card_uploaded == 'APPROVED' || is_pan_card_uploaded == 'UPLOADED'" class="green-box">
                <span><i class="el-icon-success" v-if="is_pan_card_uploaded == 'APPROVED'">&nbsp;Approved</i></span>
                <span><i class="el-icon-success" v-if="is_pan_card_uploaded == 'UPLOADED'">&nbsp;Uploaded</i></span>
              </div>
            </div>

            <div class="top-margin-15">
              <label class="input-label bottom-margin-5">Aadhar Card</label>

              <el-row :gutter="10">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <div class="blue-box" v-if="!is_aadhar_card_uploaded || is_aadhar_card_uploaded == 'REJECTED'" @click="openAadharCardFrontSideInput()">
                    <input type="file" ref="aadhar_card_front_side" style="display: none" @change="getAadharFrontFile($event)" />

                    <span><i class="el-icon-paperclip cursor-pointer" v-if="!is_aadhar_card_uploaded && !aadhar_card_front_side_file">&nbsp;Upload Front Side</i></span>

                    <span><i class="el-icon-error cursor-pointer" v-if="is_aadhar_card_uploaded == 'REJECTED'">&nbsp;Rejected</i></span>

                    <span><i class="el-icon-success" v-if="aadhar_card_front_side_file">&nbsp;Selected</i></span>
                  </div>

                  <div v-if="is_aadhar_card_uploaded == 'APPROVED' || is_aadhar_card_uploaded == 'UPLOADED'" class="blue-box">
                    <span><i class="el-icon-success" v-if="is_aadhar_card_uploaded == 'APPROVED'">&nbsp;Approved</i></span>
                    <span><i class="el-icon-success" v-if="is_aadhar_card_uploaded == 'UPLOADED'">&nbsp;Uploaded</i></span>
                  </div>
                </el-col>

                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <div class="blue-box" v-if="!is_aadhar_card_uploaded || is_aadhar_card_uploaded == 'REJECTED'" @click="openAadharCardBackSideInput()">
                    <input type="file" ref="aadhar_card_back_side" style="display: none" @change="getAadharBackFile($event)" />

                    <span><i class="el-icon-paperclip cursor-pointer" v-if="!is_aadhar_card_uploaded && !aadhar_card_back_side_file">&nbsp;Upload Back Side</i></span>

                    <span><i class="el-icon-error cursor-pointer" v-if="is_aadhar_card_uploaded == 'REJECTED'">&nbsp;Rejected</i></span>

                    <span><i class="el-icon-success" v-if="aadhar_card_back_side_file">&nbsp;Selected</i></span>
                  </div>

                  <div v-if="is_aadhar_card_uploaded == 'APPROVED' || is_aadhar_card_uploaded == 'UPLOADED'" class="blue-box">
                    <span><i class="el-icon-success" v-if="is_aadhar_card_uploaded == 'UPLOADED'">&nbsp;Uploaded</i></span>
                    <span><i class="el-icon-success" v-if="is_aadhar_card_uploaded == 'APPROVED'">&nbsp;Approved</i></span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="top-margin-15" v-if="profession != 'Dealer'">
              <div>
                <label class="input-label bottom-margin-5">GST Number</label>

                <el-input type="text" v-model="gst_no" size="small"></el-input>
              </div>
            </div>

            <div class="flex-space-between top-margin-15">
              <div class="blue" v-if="profession != 'Dealer'">
                <el-button class="btn-theme-borderd" size="small" @click="setUserProfession">Non registered SEBI Expert?</el-button>
              </div>
              <div v-else>&nbsp;</div>
              <div class="text-right">
                <el-button style="background: #e8e8e8; color: #000; border-radius: 6px" size="small" @click="skipSteps(1)">Back</el-button>

                <!-- <el-button
                  style="background: #e8e8e8; color: #000"
                  size="small"
                  @click="skipSteps(3)"
                  round
                  >Skip</el-button
                > -->

                <el-button class="btn-theme-borderd" size="small" @click="goToNextStep(3)">FINISH</el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- verify otp dialog -->
    <el-dialog custom-class="stock-widget-dialog" :visible.sync="otp_validate_dialog_visible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
      <div>
        <img src="../assets/images/logo/logo1.png" class="cursor-pointer text-center" style="width: 200px" />
        <!-- <el-row class="top-margin-15">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12"> -->
        <div
          class="form-group text-left"
          :class="{
            'not-empty': otp.length,
            'form-group--error': $v.otp.$error,
          }"
        >
          <label class="input-label-bold-gray">OTP</label>
          &nbsp;
          <span class="required-field">*</span>

          <el-input class="top-margin-10" type="text" placeholder="OTP" v-model="otp" @input="setOTP($event)"></el-input>
        </div>
        <!-- </el-col>
        </el-row> -->

        <div class="save-btn-section top-margin-20">
          <el-button class="top-margin-10 btn-secondary-theme-filled" rounded style="width: 200px" v-if="validate_mobile_otp" :loading="is_otp_verifying" @click="verifyMobileOTP()" :disabled="!otp.trim()">VERIFY OTP</el-button>

          <el-button class="btn-secondary-theme-filled" style="width: 200px" rounded v-if="validate_email_otp" :loading="is_otp_verifying" @click="verifyEmailOTP()" :disabled="!otp.trim()">VERIFY OTP</el-button>
        </div>
        <div class="text-center top-margin-5" v-if="validate_email_otp">
          <span style="color: #000; font-size: 0.7rem; font-weight: 400">
            Sometimes automated mails get categorised as spam.
            <br />
            Check your spam folder
          </span>
        </div>
        <div class="font-08rem external-link-color font-weight-500 cursor-pointer text-center top-margin-10">
          <span v-if="validate_mobile_otp" @click="sendOTPForMobileVerification()">Resend Otp</span>
          <span v-if="validate_email_otp" @click="sendOTPForEmailVerification()">Resend Otp</span>
        </div>
      </div>
    </el-dialog>

    <!-- Cropper Dialog -->
    <div class="cropper-dialog-outer">
      <el-dialog :visible.sync="isCropperVisible" :close-on-click-modal="false" :close-on-press-escape="false" class="cropper-dialog">
        <div class="cropper-modal">
          <h3 class="dialog-title">Crop Image</h3>
          <div class="cropper-preview-wrapper">
            <cropper class="cropper" :src="originalImage" :stencil-props="{ aspectRatio: 4 / 4 }" @change="({ canvas }) => (croppedImage = canvas.toDataURL('image/jpeg'))"></cropper>
          </div>
          <div class="dialog-actions">
            <button @click="cropAndUploadImage" class="btn btn-primary">Save Image</button>
            <button @click="isCropperVisible = false" class="btn btn-secondary">Cancel</button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverAddrToUploadMediaFiles, serverHostName } from '../networkConfig';
import MobileNav from '@/components/MobileNav.vue';
import { required, minValue, maxValue } from 'vuelidate/lib/validators';
import { EventBus } from '../eventBus';
import CripNotice from 'crip-vue-notice';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: 'ProfileUpdate',

  components: {
    MobileNav,
    Cropper,
  },

  mixins: [updateProfileNetworkCallBack],

  data() {
    return {
      nav_title: 'Profile Update',
      is_profile_pic_loading: false,
      is_cover_pic_loading: false,
      is_profile_save_loading: false,
      profile_pic: require('../assets/images/navBar/avatar.jpg'),
      cover_image: require('../assets/images/profile/camera.png'),
      full_name: '',
      last_name: '',
      email: '',
      selectedBrokers: [],
      mobile: '',
      profession: '',
      invesment_expe: '',
      invesment_objective: '',
      company: '',
      sebi_regi_number: '',
      institute_name: '',
      isSebiUser: true,
      file: '',
      about: '',
      website: '',
      gmail_link: '',
      facebook_link: '',
      linkedin_link: '',
      telegram_link: '',
      youtube_link: '',
      otp: '',
      gst_no: '',
      account_number: '',
      bank_name: '',
      retype_account_number: '',
      dealer_registration_number: '',
      sebi_registration_number: '',
      ifsc_code: '',
      beneficiary_name: '',
      is_mobile_verified: false,
      is_email_verified: false,
      is_otp_verifying: false,
      active_step: 1,
      broker_list: [],
      profession_list: [
        {
          value: 'Broker',
          label: 'Broker',
        },
        {
          value: 'Analyst',
          label: 'Analyst',
        },
        {
          value: 'Financial Advisor',
          label: 'Financial Advisor',
        },
        {
          value: 'Market Expert',
          label: 'Non registered SEBI Expert',
        },
      ],
      financialUser: false,
      nonFinancialUser: false,
      show_error_on_empty: true,
      mo_no_validation: false,
      validate_full_name: false,
      validate_last_name: false,
      sebi_number_error: false,
      validate_email_id: false,
      otp_validate_dialog_visible: false,
      validate_mobile_otp: false,
      validate_email_otp: false,
      validate_account_number: false,
      validate_retype_account_number: false,
      account_number_not_matching: false,
      validate_bank_name: false,
      validate_ifsc: false,
      validate_beneficiary_name: false,
      is_sebi_certificate_uploaded: false,
      is_pan_card_uploaded: false,
      is_nism_uploaded: false,
      is_aadhar_card_uploaded: false,
      is_aadhar_card_back_side_file: false,

      available_bank_name: '',
      available_account_number: '',
      available_ifsc_code: '',
      available_beneficiary_name: '',
      cancelled_cheque_status: '',
      bank_details_id: '',
      sebi_certificate_file: '',
      pan_card_file: '',
      nism_file: '',
      aadhar_card_front_side_file: '',
      aadhar_card_back_side_file: '',
      cancelled_cheque_file: '',
      serverHostName: serverHostName,
      file: '',
      coverFile: '',
      userProfile: {},
      basicProfileProgress: 5,
      kycDocProgress: 2,
      pan_card_number: null,
      risk_profiling: null,

      isCropping: false, // Toggles cropping view
      imageUrl: null, // URL of the uploaded image
      croppedBlob: null, // Cropped image as Blob
      isCropperVisible: false,
      originalImage: null,
      isValidMobileNumber: true,
      selectedCountryCode: '+91',
      countryCodes: [
        {
          name: 'India',
          country_code: '+91',
          flag: require('@/assets/images/Country-flags/India.svg'),
          length: 10,
        },
        {
          name: 'Singapore',
          country_code: '+65',
          flag: require('@/assets/images/Country-flags/Singapore.svg'),
          length: 8,
        },
        {
          name: 'United States',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/United States.svg'),
          length: 10,
        },
        {
          name: 'Canada',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/Canada.svg'),
          length: 10,
        },
        {
          name: 'Dubai',
          country_code: '+971',
          flag: require('@/assets/images/Country-flags/Dubai.svg'),
          length: 9,
        },
        {
          name: 'Saudi Arabia',
          country_code: '+966',
          flag: require('@/assets/images/Country-flags/Saudi Arabia.svg'),
          length: 9,
        },
        {
          name: 'Oman',
          country_code: '+968',
          flag: require('@/assets/images/Country-flags/Oman.svg'),
          length: 8,
        },
        {
          name: 'United Kingdom',
          country_code: '+44',
          flag: require('@/assets/images/Country-flags/United Kingdom.svg'),
          length: 10,
        },
        {
          name: 'Australia',
          country_code: '+61',
          flag: require('@/assets/images/Country-flags/Australia.svg'),
          length: 9,
        },
      ],
    };
  },

  watch: {
    profession: function (newProfession, oldProfession) {
      this.sebi_number_error = false;

      if (this.profession != 'Broker') {
        this.sebi_regi_number = '';
      }
    },

    userProfile(newValue) {},

    sebi_regi_number: function (newNumber, oldNumber) {
      if (newNumber) {
        this.sebi_number_error = true;
        let regex = /^([a-zA-Z0-9]{12,12})$/; //regex to validate string for aplha numeric 12 character string
        if (regex.test(newNumber)) {
          this.sebi_number_error = false;
        } else {
          this.sebi_number_error = true;
        }
      } else {
        this.sebi_number_error = false;
      }
    },
  },

  validations: {
    full_name: {
      required,
    },
    last_name: {
      required,
    },
    selectedBrokers: {
      required,
    },
    dealer_registration_number: {
      required,
    },
    email: {
      required,
    },
    mobile: {
      required,
    },
    profession: {
      required,
    },
    company: {
      required,
    },
    institute_name: {
      required,
    },
    otp: {
      required,
    },
    account_number: {
      required,
    },
    retype_account_number: {
      required,
    },
    bank_name: {
      required,
    },
    ifsc_code: {
      required,
    },
    beneficiary_name: {
      required,
    },
  },

  created() {
    this.user_id = JSON.parse(localStorage.getItem('user_id'));
    this.getUserProfile();
    // this.getBankDetailsNetworkCallBack();

    if (this.$route.params.active_step == 2) {
      this.active_step = 2;
    }
  },

  mounted() {
    if (localStorage.getItem('profile')) {
      this.userProfile = JSON.parse(localStorage.getItem('profile'));
    }
    EventBus.$on('userData', (data) => {
      this.userProfile = data;
    });

    if (this.userProfile && this.userProfile.picture.length) {
      this.profile_pic = this.serverHostName + this.userProfile.picture;
    }
    if (this.userProfile && this.userProfile.cover_image.length) {
      this.cover_image = this.serverHostName + this.userProfile.cover_image;
    }

    if (this.userProfile.full_name && this.userProfile.email && !this.userProfile.mobile && !this.userProfile.profession && !this.userProfile.company) {
      this.basicProfileProgress = 10;
    } else if (this.userProfile.full_name && this.userProfile.email && this.userProfile.mobile && !this.userProfile.profession && !this.userProfile.company) {
      this.basicProfileProgress = 20;
    } else if (this.userProfile.full_name && this.userProfile.email && this.userProfile.mobile && this.userProfile.profession && !this.userProfile.company) {
      this.basicProfileProgress = 30;
    } else if (this.userProfile.full_name && this.userProfile.email && this.userProfile.mobile && this.userProfile.profession && this.userProfile.company) {
      this.basicProfileProgress = 80;
    }

    if (this.userProfile.mobile_verified && this.userProfile.email_verified) {
      this.basicProfileProgress = 100;
    }

    if (this.is_sebi_certificate_uploaded && !this.is_pan_card_uploaded && !this.is_aadhar_card_uploaded && !this.gst_no) {
      this.kycDocProgress = 25;
    } else if (this.is_sebi_certificate_uploaded && this.is_pan_card_uploaded && !this.is_aadhar_card_uploaded && !this.gst_no) {
      this.kycDocProgress = 50;
    } else if (this.is_sebi_certificate_uploaded && this.is_pan_card_uploaded && this.is_aadhar_card_uploaded && !this.gst_no) {
      this.kycDocProgress = 75;
    } else if (this.is_sebi_certificate_uploaded && this.is_pan_card_uploaded && this.is_aadhar_card_uploaded && this.gst_no) {
      this.kycDocProgress = 100;
    }
  },

  methods: {
    // Get the max length for the selected country code
    getMaxLength() {
      const selectedCountry = this.countryCodes.find((country) => country.country_code === this.selectedCountryCode);
      return selectedCountry ? selectedCountry.length : 10; // Default to 10 if not found
    },

    // Validate the mobile number length and numeric content
    validateMobileNumber() {
      const maxLength = this.getMaxLength();

      // Check if the mobile number is numeric and matches the required length
      const isNumeric = /^\d+$/.test(this.mobile); // Check if the input is numeric
      this.isValidMobileNumber = isNumeric && this.mobile.length === maxLength;

      // Set the `mo_no_validation` flag for error message display
      this.mo_no_validation = this.mobile.length > 0 && !this.isValidMobileNumber;
    },
    handleFileUpload(inputData) {
      if (inputData === 'profile') {
        const temp_file = this.$refs.file.files[0];
        if (temp_file) {
          const fileType = temp_file.type.split('/').pop().toLowerCase();
          if (['jpeg', 'jpg', 'png', 'bmp', 'gif'].includes(fileType)) {
            // Open the cropper modal
            this.originalImage = URL.createObjectURL(temp_file); // Set the original image for cropping
            this.isCropperVisible = true; // Show the cropper modal
          } else {
            this.showError('Please select a valid image format.');
          }
        }
      }
    },
    cropAndUploadImage() {
      if (this.croppedImage) {
        // Convert the cropped image to a file
        fetch(this.croppedImage)
          .then((res) => res.blob())
          .then((blob) => {
            const croppedFile = new File([blob], 'profile.jpg', { type: 'image/jpeg' });

            const formData = new FormData();
            formData.append('pic', croppedFile);

            this.is_profile_pic_loading = true; // Enable loader

            // API call to upload the cropped image
            serverAddrToUploadMediaFiles
              .post('/auth/v1/avatar', formData)
              .then((response) => {
                if (response.data.status) {
                  // Update profile picture in the UI and local storage
                  EventBus.$emit('profilePic', response.data.profile_url);
                  const profile = JSON.parse(localStorage.getItem('profile'));
                  this.$set(profile, 'picture', response.data.profile_url);
                  localStorage.setItem('profile', JSON.stringify(profile));

                  document.getElementById('profile').src = this.croppedImage; /// Set profile picture
                  this.is_profile_pic_loading = false; // Disable loader
                  this.isCropperVisible = false; // Close the cropper modal
                }
              })
              .catch((error) => {
                console.error(error);
                this.is_profile_pic_loading = false; // Disable loader
              });
          });
      }
    },
    showError(message) {
      new CripNotice({
        title: 'Error',
        description: message,
        type: 'error',
        duration: 3,
      });
    },

    // Called when the cropper emits change events
    onCropChange({ coordinates, canvas }) {
      if (canvas) {
        canvas.toBlob((blob) => {
          this.croppedBlob = blob; // Store the cropped image Blob
        }, 'image/jpeg');
      }
    },

    // Save the cropped image
    saveCroppedImage() {
      if (this.croppedBlob) {
        this.is_profile_pic_loading = true;

        // Optional: Preview the cropped image
        this.profile_pic = URL.createObjectURL(this.croppedBlob);

        // Prepare the cropped image for API upload
        const formData = new FormData();
        formData.append('profile_image', this.croppedBlob, 'profile.jpg');

        // Simulate an API call to upload the profile image
        setTimeout(() => {
          console.log('Profile image uploaded:', formData);
          this.is_profile_pic_loading = false;
          this.isCropping = false; // Hide the cropper
          alert('Profile picture updated successfully!');
        }, 2000);
      }
    },

    // Cancel cropping
    cancelCropping() {
      this.isCropping = false; // Hide the cropper
      this.imageUrl = null;
      this.croppedBlob = null;
    },

    goToExpertStore() {
      // if (this.userProfile.profession != 'Retail Investor') {
      this.$router.push({
        path: '/expert-store',
        query: {
          user_id: this.userProfile.id,
          user: 'individual',
          name: this.userProfile.full_name,
        },
      });
      // }
    },

    goToNextStep(step) {
      if (step == 2) {
        this.saveProfileDetails();
      } else if (step == 3) {
        this.uploadKycDocuments();
      } else {
        this.validateBankDetails();
      }
    },

    openSEBICertificateInput() {
      this.$refs.sebi_certificate.click();
    },

    openPANCardInput() {
      this.$refs.pan_card.click();
    },

    openAadharCardFrontSideInput() {
      this.$refs.aadhar_card_front_side.click();
    },

    openNISMInput() {
      this.$refs.nism_certificate.click();
    },

    openAadharCardBackSideInput() {
      this.$refs.aadhar_card_back_side.click();
    },

    getNISMFile(e) {
      if (e.target.files.length) {
        this.nism_file = e.target.files[0];
      }
    },

    getSEBIFile(e) {
      if (e.target.files.length) {
        this.sebi_certificate_file = e.target.files[0];
      }
    },

    getPANFile(e) {
      if (e.target.files.length) {
        this.pan_card_file = e.target.files[0];
      }
    },

    getAadharFrontFile(e) {
      if (e.target.files.length) {
        this.aadhar_card_front_side_file = e.target.files[0];
      }
    },

    getAadharBackFile(e) {
      if (e.target.files.length) {
        this.aadhar_card_back_side_file = e.target.files[0];
      }
    },

    getCheque(e) {
      if (e.target.files.length) {
        this.cancelled_cheque_file = e.target.files[0];
      }
    },

    skipSteps(step) {
      this.active_step = step;

      if (step == 1) {
        this.getUserProfile();
      }

      this.sebi_certificate_file = '';
      this.pan_card_file = '';
      this.aadhar_card_front_side_file = '';
      this.aadhar_card_back_side_file = '';
      this.cancelled_cheque_file = '';
      this.nism_file = '';
    },

    setFirstname(value) {
      if (value) {
        this.full_name = value;
        this.$v.full_name.$touch();
        var letters = /^[A-Za-z_ ]+$/;
        if (this.full_name.match(letters)) {
          this.validate_full_name = false;
        } else if (this.full_name != '') {
          this.validate_full_name = true;
        }
      }
    },

    setLastname(value) {
      if (value) {
        this.last_name = value.trim();
        this.$v.last_name.$touch();
        var letters = /^[A-Za-z]+$/;

        if (this.last_name.match(letters)) {
          this.validate_last_name = false;
        } else if (this.last_name != '') {
          this.validate_last_name = true;
        }
      }
    },

    setEmail(value) {
      this.email = value.trim();
      this.$v.email.$touch();

      let email_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (this.email.match(email_regex)) {
        this.validate_email_id = false;
      } else {
        this.validate_email_id = true;
      }
    },

    setMobile(value) {
      if (value) {
        this.mobile = value.trim();
        this.$v.mobile.$touch();
        var numbers = /^[0-9]+$/;
        if (this.mobile.match(numbers)) {
          this.mo_no_validation = false;
          if (this.mobile.length === 10) {
            this.mo_no_validation = false;
          } else {
            this.mo_no_validation = true;
          }
        } else {
          this.mo_no_validation = true;
        }
      }
    },

    setProfession(value) {
      this.profession = value;
      this.$v.profession.$touch();
    },

    setBrokerName(value) {
      this.selectedBrokers = value;
      this.$v.selectedBrokers.$touch();
    },

    setBrokerRegistrationNumber(value) {
      this.dealer_registration_number = value;
      this.$v.dealer_registration_number.$touch();
    },

    setCompanyName(value) {
      this.company = value;
      this.$v.company.$touch();
    },

    // setSEBI(value) {
    //   this.sebi_regi_number = value;
    //   this.$v.sebi_regi_number.$touch();
    // },

    setInstitute(value) {
      this.institute_name = value;
      this.$v.institute_name.$touch();
    },

    setOTP(value) {
      this.otp = value;
      this.$v.otp.$touch();
    },

    setAccountNumber(value) {
      this.account_number = value.trim();
      this.$v.account_number.$touch();

      var numbers = /^[0-9]+$/;

      if (this.account_number.match(numbers)) {
        this.validate_account_number = false;

        if (this.retype_account_number) {
          if (this.retype_account_number == this.account_number) {
            this.account_number_not_matching = false;
          } else {
            this.account_number_not_matching = true;
          }
        } else {
          this.account_number_not_matching = false;
        }
      } else {
        this.validate_account_number = true;
      }
    },

    setRetypeAccountNumber(value) {
      this.retype_account_number = value.trim();
      this.$v.retype_account_number.$touch();

      var numbers = /^[0-9]+$/;

      if (this.retype_account_number.match(numbers)) {
        this.validate_retype_account_number = false;
        this.account_number_not_matching = false;

        if (this.account_number != this.retype_account_number) {
          this.account_number_not_matching = true;
        } else {
          this.account_number_not_matching = false;
        }
      } else {
        this.validate_retype_account_number = true;
        this.account_number_not_matching = false;
      }
    },

    setBankName(value) {
      if (value.trim()) {
        this.$v.bank_name.$touch();
        var letters = /^[A-Za-z_ ]+$/;
        if (this.bank_name.match(letters)) {
          this.validate_bank_name = false;
        } else {
          this.validate_bank_name = true;
        }
      } else {
        this.validate_bank_name = true;
      }
    },

    setIFSC(value) {
      if (value.trim()) {
        this.$v.ifsc_code.$touch();
        let letters = /^([a-zA-Z0-9]{11,11})$/;

        if (this.ifsc_code.match(letters)) {
          this.validate_ifsc = false;
        } else {
          this.validate_ifsc = true;
        }
      } else {
        this.validate_ifsc = true;
      }
    },

    setBeneficiaryName(value) {
      if (value.trim()) {
        this.$v.beneficiary_name.$touch();
        var letters = /^[A-Za-z_ ]+$/;
        if (this.beneficiary_name.match(letters)) {
          this.validate_beneficiary_name = false;
        } else {
          this.validate_beneficiary_name = true;
        }
      } else {
        this.validate_beneficiary_name = true;
      }
    },
    // for all user --- corporate and individual users basic profile is compulsory -->
    //e.g. basic profile --- >first name, last name, email, mobile no, profession

    // if user is corporate --->
    //for broker sebi no and company name compulsory
    //for analyst company name compulsory
    //for financial advisor company name compulsory

    //if user is individual --->
    //for broker sebi no and company name compulsory
    //for analyst, financial advisor, other user only basic profile compulsory
    //for student insitute name compulsory

    saveProfileDetails() {
      this.show_error_on_empty = true;

      this.$v.$touch();

      if (this.mobile != '' && !this.mo_no_validation && this.full_name != '' && this.email != '' && this.profession != '' && !this.validate_full_name && !this.validate_email_id) {
        //
        if (this.is_mobile_verified && this.is_email_verified) {
          if (this.profession == 'Broker' && this.company) {
            this.save();
          } else if (this.profession == 'Analyst' || this.profession == 'Financial Advisor' || this.profession == 'Other' || this.profession == 'Retail Investor' || this.profession == 'Market Expert') {
            this.save();
          } else if (this.profession == 'Dealer') {
            if (this.isSebiUser) {
              if (this.selectedBrokers && this.dealer_registration_number) {
                this.save();
              } else {
                this.$message({
                  customClass: 'notification-tag',
                  showClose: true,
                  message: 'Please fill all required fields!',
                  type: 'error',
                });
              }
            } else if (this.selectedBrokers && this.dealer_registration_number) {
              this.save();
            } else {
              this.$message({
                customClass: 'notification-tag',
                showClose: true,
                message: 'Please fill all required fields!',
                type: 'error',
              });
            }
          }
        } else {
          this.$message({
            customClass: 'notification-tag',
            showClose: true,
            message: 'Mobile no. or Email id is not verfied',
            type: 'error',
          });
        }
      } else {
        this.$message({
          customClass: 'notification-tag',
          showClose: true,
          message: 'Please fill all required fields!',
          type: 'error',
        });
      }

      //checked required fileds without error
      // if(this.full_name !='' && this.last_name !='' && this.email !='' && this.mobile !='' && this.profession !='' && !this.validate_full_name && !this.validate_last_name && !this.mo_no_validation){

      //   if(this.sebi_regi_number !='' && (this.profession == 'Broker' || this.profession == 'Financial Advisor') && this.company){
      //     if(!this.sebi_number_error){
      //       this.save();
      //     }else{
      //       this.sebi_number_error = true;
      //     }
      //   }else{
      //     // checked profession wise company name is required or not
      //     if((this.profession == 'Broker' || this.profession == 'Financial Advisor' || this.profession == 'Analyst') && this.company){
      //       this.save();
      //     }else if(this.profession == 'Student' || this.profession == 'Other'){
      //       this.save();
      //     }
      //   }
      // }
    },
    setUserProfession() {
      this.profession = 'Market Expert';
      this.active_step = 1;

      // call api for set profession as 'Market Expert'
      this.save();
    },

    // api to save profile info
    save() {
      this.is_profile_save_loading = true;

      serverAddr
        .post('/auth/v1/profile', {
          full_name: this.full_name,
          email: this.email,
          mobile: this.mobile,
          address: this.address,
          profession: this.profession,
          company: this.profession != 'Student' ? this.company : '',
          sebi_regi_number: this.profession != 'Student' || this.profession != 'Other' ? this.sebi_regi_number : '',
          institute_name: this.profession == 'Student' ? this.institute_name : '',
          about_us: this.about,
          website: this.website ? this.website : null,
          gmail: this.gmail_link ? this.gmail_link : null,
          facebook: this.facebook_link ? this.facebook_link : null,
          linkedin: this.linkedin_link ? this.linkedin_link : null,
          telegram: this.telegram_link ? this.telegram_link : null,
          youtube: this.youtube_link ? this.youtube_link : null,
          dealer_of: this.profession == 'Dealer' ? this.selectedBrokers : null,
          broker_registration_no: this.profession == 'Dealer' ? this.dealer_registration_number : null,
          sebi_regi_number: this.profession == 'Dealer' && this.isSebiUser ? this.sebi_registration_number : null,
        })
        .then(this.updateProfileCallBack)
        .catch(function (error) {
          console.log(error);

          this.is_profile_save_loading = false;
        });
      // this.$refs.file.value = null;
    },
    isProfileUpdateAllowed() {
      if (this.profession === 'Dealer') {
        return this.is_sebi_certificate_uploaded && this.is_pan_card_uploaded && this.is_aadhar_card_uploaded && this.is_nism_uploaded;
      } else {
        return this.is_sebi_certificate_uploaded && this.is_pan_card_uploaded && this.is_aadhar_card_uploaded && this.gst_no;
      }

      return false;
    },

    uploadKycDocuments() {
      if (this.isProfileUpdateAllowed()) {
        if (localStorage.getItem('premiumPlanSubscriptionDialogVisible')) {
          this.$router.push({ path: '/pricing' });
        } else {
          this.$router.push('/experts-past-recommendations');
        }
        // this.active_step = 3;
      } else {
        if (this.sebi_certificate_file || this.pan_card_file || this.aadhar_card_front_side_file || this.aadhar_card_back_side_file || this.gst_no || this.nism_file) {
          let formData = new FormData();

          if (this.sebi_certificate_file) {
            formData.append('sebi_certificate', this.sebi_certificate_file);
          }

          if (this.pan_card_file) {
            formData.append('pan_card', this.pan_card_file);
          }

          if (this.aadhar_card_front_side_file || this.aadhar_card_back_side_file) {
            if (this.aadhar_card_front_side_file && !this.aadhar_card_back_side_file) {
              this.$message({
                customClass: 'notification-tag',
                showClose: true,
                message: 'Please select aadhar card back side too',
                type: 'error',
              });

              return;
            }

            if (!this.aadhar_card_front_side_file && this.aadhar_card_back_side_file) {
              this.$message({
                customClass: 'notification-tag',
                showClose: true,
                message: 'Please select aadhar card front side too',
                type: 'error',
              });

              return;
            }

            if (this.aadhar_card_front_side_file) {
              formData.append('aadhar_card_front', this.aadhar_card_front_side_file);
            }

            if (this.aadhar_card_back_side_file) {
              formData.append('aadhar_card_back', this.aadhar_card_back_side_file);
            }
          }

          // if (this.profession == "Dealer" && !this.nism_file) {
          //   this.$message({
          //     customClass: "notification-tag",
          //     showClose: true,
          //     message: "Please select NISM certificate",
          //     type: "error",
          //   });
          //   return;
          // }

          if (this.profession == 'Dealer' && this.nism_file) {
            formData.append('nism_certificate', this.nism_file);
          }

          if (this.gst_no) {
            formData.append('gst_number', this.gst_no);
          }

          this.is_profile_save_loading = true;

          serverAddrToUploadMediaFiles
            .post('/auth/v1/kyc_doc', formData)
            .then((response) => {
              if (response.data.status) {
                // this.active_step = 3;

                this.is_sebi_certificate_uploaded = response.data.data.sebi_certificate_status;
                this.is_pan_card_uploaded = response.data.data.pan_card_status;
                this.is_aadhar_card_uploaded = response.data.data.aadhar_card_status;
                this.gst_no = response.data.data.gst_number;

                if (this.sebi_certificate_file) {
                  this.sebi_certificate_file = '';
                  // this.$refs.sebi_certificate.files = [];
                }

                if (this.pan_card_file) {
                  this.pan_card_file = '';
                  // this.$refs.pan_card.files = [];
                }

                if (this.aadhar_card_front_side_file) {
                  this.aadhar_card_front_side_file = '';
                  // this.$refs.aadhar_card_front_side.files = [];
                }

                if (this.aadhar_card_back_side_file) {
                  this.aadhar_card_back_side_file = '';
                  // this.$refs.aadhar_card_back_side.files = [];
                }

                new CripNotice({
                  title: 'Success',
                  description: 'KYC documents updated!',
                  type: 'success',
                  duration: 3,
                });
                if (localStorage.getItem('premiumPlanSubscriptionDialogVisible')) {
                  this.$router.push({ path: '/pricing' });
                } else {
                  this.$router.push('/experts-past-recommendations');
                }
              }

              this.is_profile_save_loading = false; //disabled loader
            })
            .catch((error) => {
              console.log(error);
              this.is_profile_save_loading = false; //disabled loader
            });
        } else {
          this.$message({
            customClass: 'notification-tag',
            showClose: true,
            message: 'Please select file to upload',
            type: 'error',
          });
        }
      }
    },

    validateBankDetails() {
      if (this.account_number && !this.validate_account_number && !this.account_number_not_matching && this.retype_account_number && !this.validate_retype_account_number && !this.account_number_not_matching && this.ifsc_code && !this.validate_ifsc && this.bank_name && !this.validate_bank_name && this.beneficiary_name && !this.validate_beneficiary_name) {
        this.saveBankDetails();
      } else {
        new CripNotice({
          title: 'Oops! Something went wrong!',
          description: 'Please fill all required details',
          type: 'error',
          duration: 3,
        });
      }
    },

    // api to sav bank details
    saveBankDetails() {
      this.is_profile_save_loading = true; //enabled loader

      if (this.bank_details_id) {
        serverAddr
          .patch(`/auth/v1/bank/${this.bank_details_id}`, {
            account_number: this.account_number,
            ifsc_code: this.ifsc_code,
            bank_name: this.bank_name,
            mobile: this.mobile_number,
            beneficiary_name: this.beneficiary_name,
          })
          .then(async (response) => {
            if (response.data.status) {
              this.account_number = response.data.data.account_number;
              this.ifsc_code = response.data.data.ifsc_code;
              this.bank_name = response.data.data.bank_name;
              this.beneficiary_name = response.data.data.beneficiary_name;

              this.available_bank_name = response.data.data.bank_name;
              this.available_account_number = response.data.data.account_number;
              this.available_ifsc_code = response.data.data.ifsc_code;
              this.available_beneficiary_name = response.data.data.beneficiary_name;
              this.cancelled_cheque_status = response.data.data.cancelled_cheque_status;
              this.bank_details_id = response.data.data.id;

              if (this.$refs.cancelled_cheque && this.$refs.cancelled_cheque.files.length) {
                let upload_cheque_res = await this.uploadCancelledCheque(this.$refs.cancelled_cheque.files[0], this.bank_details_id);

                if (upload_cheque_res.data.status) {
                  this.cancelled_cheque_status = upload_cheque_res.data.data.cancelled_cheque_status;
                  this.cancelled_cheque_file = '';
                  // this.$refs.cancelled_cheque.files = [];
                }
              }

              new CripNotice({
                title: 'Success',
                description: 'Updated bank details',
                type: 'success',
                duration: 3,
              });
              if (localStorage.getItem('premiumPlanSubscriptionDialogVisible')) {
                this.$router.push({ path: '/pricing' });
              } else {
                this.$router.push('/experts-past-recommendations');
              }
            }
            this.is_profile_save_loading = false; //disabled loader
          })
          .catch((error) => {
            console.log(error);
            this.is_profile_save_loading = false; //disabled loader
          });
      } else {
        serverAddr
          .post('/auth/v1/bank', {
            account_number: this.account_number,
            ifsc_code: this.ifsc_code,
            bank_name: this.bank_name,
            mobile: this.mobile_number,
            beneficiary_name: this.beneficiary_name,
          })
          .then(async (response) => {
            if (response.data.status) {
              this.account_number = response.data.data.account_number;
              this.ifsc_code = response.data.data.ifsc_code;
              this.bank_name = response.data.data.bank_name;
              this.beneficiary_name = response.data.data.beneficiary_name;

              this.available_bank_name = response.data.data.bank_name;
              this.available_account_number = response.data.data.account_number;
              this.available_ifsc_code = response.data.data.ifsc_code;
              this.available_beneficiary_name = response.data.data.beneficiary_name;
              this.cancelled_cheque_status = response.data.data.cancelled_cheque_status;
              this.bank_details_id = response.data.data.id;

              if (this.$refs.cancelled_cheque.files.length) {
                let upload_cheque_res = await this.uploadCancelledCheque(this.$refs.cancelled_cheque.files[0], this.bank_details_id);

                if (upload_cheque_res.data.status) {
                  this.cancelled_cheque_status = upload_cheque_res.data.data.cancelled_cheque_status;
                  this.cancelled_cheque_file = '';
                  // this.$refs.cancelled_cheque.files = [];
                }
              }

              new CripNotice({
                title: 'Success',
                description: 'Updated bank details',
                type: 'success',
                duration: 3,
              });
              if (localStorage.getItem('premiumPlanSubscriptionDialogVisible')) {
                this.$router.push({ path: '/pricing' });
              } else {
                this.$router.push('/experts-past-recommendations');
              }
            }
            this.is_profile_save_loading = false; //disabled loader
          })
          .catch((error) => {
            console.log(error);
            this.is_profile_save_loading = false; //disabled loader
          });
      }
    },

    // api to upload cancelled cheque
    uploadCancelledCheque(files_obj, id) {
      let formData = new FormData();

      if (files_obj) {
        formData.append('cancelled_cheque', files_obj);
      }

      return serverAddrToUploadMediaFiles
        .post(`/auth/v1/bank/cancelled_cheque_upload/${id}`, formData)
        .then((response) => {
          return response;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // api to send otp on mobile no.
    sendOTPForMobileVerification() {
      if (this.mobile && !this.mo_no_validation) {
        serverAddr
          .post('/auth/v1/generate_mobile_otp', {
            mobile: this.mobile,
            purpose: 'MOBILE_VERIFICATION',
            country_code: this.selectedCountryCode,
          })
          .then((response) => {
            if (response.data.status) {
              this.otp = '';
              this.otp_validate_dialog_visible = true; //displayed dialog to verify otp

              this.validate_mobile_otp = true; //to toggle otp buttons

              new CripNotice({
                title: 'Success',
                description: response.data.validation,
                type: 'success',
                duration: 3,
              });
            } else {
              this.otp_validate_dialog_visible = false; //closed dialog to verify otp
              this.validate_mobile_otp = false; //to toggle otp buttons
            }
          })
          .catch(function (error) {
            console.log(error);
            this.otp_validate_dialog_visible = false; //closed dialog to verify otp
            this.validate_mobile_otp = false; //to toggle otp buttons
          });
      }
    },

    // api to send otp on email id.

    sendOTPForEmailVerification() {
      if (this.email && !this.validate_email_id) {
        serverAddr
          .post('/auth/v1/generate_email_otp', {
            email_id: this.email,
            purpose: 'BROKER_EMAIL_VERIFICATION',
          })
          .then((response) => {
            if (response.data.status) {
              this.otp = '';
              this.otp_validate_dialog_visible = true; //displayed dialog to verify otp

              this.validate_email_otp = true; //to toggle otp buttons

              new CripNotice({
                title: 'Success',
                description: response.data.validation,
                type: 'success',
                duration: 3,
              });
            } else {
              this.otp_validate_dialog_visible = false; //closed dialog to verify otp
              this.validate_email_otp = false; //to toggle otp buttons
            }
          })
          .catch(function (error) {
            console.log(error);
            this.otp_validate_dialog_visible = false; //closed dialog to verify otp
            this.validate_email_otp = false; //to toggle otp buttons
          });
      }
    },

    // api to verify mobile otp
    verifyMobileOTP() {
      if (this.mobile && !this.mo_no_validation && this.otp) {
        serverAddr
          .post('/auth/v1/validate_mobile_otp', {
            mobile: this.mobile,
            mobile_otp: Number(this.otp),
            user_id: this.userProfile.id,
            purpose: 'MOBILE_VERIFICATION',
            country_code: this.selectedCountryCode,
          })
          .then((response) => {
            if (response.data.status) {
              this.is_mobile_verified = true; //to show verified text

              this.validate_mobile_otp = false;

              this.getUserProfile();

              new CripNotice({
                title: 'Success',
                description: response.data.validation,
                type: 'success',
                duration: 3,
              });

              this.otp_validate_dialog_visible = false; //closed dialog to verify otp
            } else {
              this.is_mobile_verified = false; //display verify mobile no text
            }
          })
          .catch(function (error) {
            console.log(error);

            this.is_mobile_verified = false; //display verify mobile no text

            new CripNotice({
              title: 'Error',
              description: response.data.validation,
              type: 'error',
              duration: 3,
            });
          });
      }
    },

    // api to verify email id
    verifyEmailOTP() {
      if (this.email && !this.validate_email_id && this.otp) {
        serverAddr
          .post('/auth/v1/validate_email_otp', {
            email_id: this.email,
            email_otp: Number(this.otp),
            profile_id: this.userProfile.id,
            purpose: 'BROKER_EMAIL_VERIFICATION',
          })
          .then((response) => {
            if (response.data.status) {
              this.is_email_verified = true; //to show verified text

              this.validate_email_otp = false;

              this.getUserProfile();

              new CripNotice({
                title: 'Success',
                description: response.data.validation,
                type: 'success',
                duration: 3,
              });

              this.otp_validate_dialog_visible = false; //closed dialog to verify otp
            } else {
              this.is_email_verified = false; //display verify email text
            }
          })
          .catch(function (error) {
            console.log(error);

            this.is_email_verified = false; //display verify email text

            new CripNotice({
              title: 'Error',
              description: response.data.validation,
              type: 'error',
              duration: 3,
            });
          });
      }
    },

    // close validate otp dialog
    handleClose() {
      this.otp_validate_dialog_visible = false;

      this.validate_email_otp = false; //to toggle otp buttons
      this.validate_mobile_otp = false; //to toggle otp buttons
    },

    // api to get profile data e.g. name, email
    getUserProfile() {
      this.is_profile_save_loading = true; //enabled loader

      serverAddr
        .get('/auth/v1/profile')
        .then(this.getProfileCallBack)
        .catch(function (error) {
          console.log(error);
        });
    },
    // api to get bank details
    getBankDetailsNetworkCallBack() {
      serverAddr
        .get('/auth/v1/bank')
        .then((response) => {
          if (response.data.status && response.data.data.length) {
            this.account_number = response.data.data[0].account_number;
            this.retype_account_number = response.data.data[0].account_number;
            this.ifsc_code = response.data.data[0].ifsc_code;
            this.bank_name = response.data.data[0].bank_name;
            this.beneficiary_name = response.data.data[0].beneficiary_name;

            this.available_bank_name = response.data.data[0].bank_name;
            this.available_account_number = response.data.data[0].account_number;
            this.available_ifsc_code = response.data.data[0].ifsc_code;
            this.available_beneficiary_name = response.data.data[0].beneficiary_name;
            this.cancelled_cheque_status = response.data.data[0].cancelled_cheque_status;
            this.bank_details_id = response.data.data[0].id;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // api to upload profile picture
    // handleFileUpload(inputData) {
    //   if (inputData == 'profile') {
    //     var temp_file;
    //     temp_file = this.$refs.file.files[0];

    //     if (temp_file) {
    //       var t = temp_file.type.split('/').pop().toLowerCase();
    //       if (t == 'jpeg' || t == 'jpg' || t == 'png' || t == 'bmp' || t == 'gif') {
    //         //check image type validation

    //         this.file = temp_file; //image file set in v-model
    //         let formData = new FormData();
    //         formData.append('pic', this.file);

    //         this.is_profile_pic_loading = true; //enable profile pic loader
    //         serverAddrToUploadMediaFiles
    //           .post('/auth/v1/avatar', formData)
    //           .then((response) => {
    //             if (response.data.status) {
    //               EventBus.$emit('profilePic', response.data.pic); //emitted event to update profile pic at navbar, sidebar
    //               let profile = JSON.parse(localStorage.getItem('profile'));
    //               this.$set(profile, 'picture', response.data.pic);
    //               localStorage.setItem('profile', JSON.stringify(profile)); //updated profile pic in localstorage

    //               document.getElementById('profile').src = URL.createObjectURL(this.file); //set profile picture
    //               this.is_profile_pic_loading = false; //disable profile pic loader
    //             }
    //           })
    //           .catch(function (error) {
    //             console.log(error);
    //           });
    //       }
    //     } else {
    //       new CripNotice({
    //         title: 'Error',
    //         description: 'Please Select Valid Image Format',
    //         type: 'error',
    //         duration: 3,
    //       });
    //     }
    //   } else {
    //     var temp_file2 = this.$refs.coverFile.files[0];
    //     // var temp_file2 = this.$refs.coverFile.files[0];
    //     if (temp_file2) {
    //       var t = temp_file2.type.split('/').pop().toLowerCase();
    //       if (t == 'jpeg' || t == 'jpg' || t == 'png' || t == 'bmp' || t == 'gif') {
    //         //check image type validation

    //         this.coverFile = temp_file2; //image file set in v-model
    //         let formData = new FormData();
    //         formData.append('pic', this.coverFile);

    //         this.is_cover_pic_loading = true; //enable cover pic loader
    //         serverAddrToUploadMediaFiles
    //           .post('/auth/v1/cover_image', formData)
    //           .then((response) => {
    //             if (response.data.status) {
    //               // EventBus.$emit("profilePic", response.data.pic); //emitted event to update profile pic at navbar, sidebar
    //               // let profile = JSON.parse(localStorage.getItem("profile"));
    //               // this.$set(profile, "picture", response.data.pic);
    //               // localStorage.setItem("profile", JSON.stringify(profile)); //updated profile pic in localstorage

    //               document.getElementById('cover_pic').src = URL.createObjectURL(this.coverFile); //set profile picture
    //               this.is_cover_pic_loading = false; //disable cover pic loader
    //             }
    //           })
    //           .catch(function (error) {
    //             console.log(error);
    //           });
    //       }
    //     } else {
    //       new CripNotice({
    //         title: 'Error',
    //         description: 'Please Select Valid Image Format',
    //         type: 'error',
    //         duration: 3,
    //       });
    //     }
    //   }
    // },
  },

  beforeDestroy() {
    EventBus.$off();
  },
  computed: {
    selectedCountry() {
    return this.countryCodes.find(country => country.country_code === this.selectedCountryCode) || null;
  },
    // shouldShowDetails() {
    //   const hasPremiumPlans = this.userProfile && this.userProfile.no_of_premium_plan_purchased > 0;
    //   return hasPremiumPlans;
    // },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.ProfileUpdate {
  min-height: 100vh;
  background-color: $page-background-color;
  padding: 60px 0 0 0;
}

.profile-update-container {
  padding: 20px 20px 50px 20px;
}

.form-section {
  width: 52%;
  margin: 10px auto 0 auto;

  .bullets {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    width: 15px;
    height: 15px;
    text-align: center;
    font-size: 0.6rem;
    font-weight: 600;
    border-radius: 50%;
  }
}

.blue-box {
  background: #edf5ff;
  color: #3792ff;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 13px 10px;
  border: 1px dotted #88beff;
  text-align: center;
  border-radius: 10px;
  // cursor: pointer;
}

.green-box {
  background: #efffef;
  color: #54cf59;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 13px 10px;
  border: 1px dotted #6ed772;
  text-align: center;
  border-radius: 10px;
  // cursor: pointer;
}

.profile-pic-upload-section {
  height: 100px;
  max-width: 100px;
  // margin: 0 auto;
  border-radius: 100%;
  position: relative;
  margin-top: 30px;

  text-align: center;

  // .profile-pic-upload {
  //   width: 150px;
  //   height: 150px;
  //   border-radius: 50%;
  //   object-fit: cover;
  //   border: 2px solid #ddd;
  // }
  .profile-pic-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #000;
  }
}

.cover-pic-upload-section {
  // height: 100px;
  // max-width: 100px;
  // margin: 0 auto;
  // border-radius: 100%;
  position: relative;
  margin-top: 30px;
}

.cover-pic-inner {
  height: 100px;
  max-width: 250px;
  background: #c6cad1;
  // margin: 0 auto;
  border-radius: 10px;
  // position: relative;
}

.profile-pic-upload {
  height: 100px;
  width: 100px;
  object-fit: cover;
  border-radius: 100%;
}

.cover-pic-upload {
  object-fit: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 100%;
  border-radius: 10px;
}

.camera-icon {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 100px;
}

.select-file {
  border-radius: 100%;
  opacity: 0;
  position: absolute;
  // background-color: rgba(0,0,0,0.6);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100px;
  width: 100px;
}

.select-cover-file {
  border-radius: 100%;
  opacity: 0;
  position: absolute;
  // background-color: rgba(0,0,0,0.6);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100px;
  max-width: 250px;
}

.profile-pic-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  top: 20px;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100px;
  width: 100px;

  i {
    font-size: 20px;
    font-weight: 700;
    color: #fff;
  }
}

.cover_pic_loader {
  height: 100px;
  width: 250px;
  border-radius: 10px;
}

//  .profile-pic-upload-section:hover .select-file{
//     border-radius: 100%;
//     opacity: 1;
//     position: absolute;
//     background-color: rgba(0,0,0,0.6);
//     top: 0;
//     height: 100px;
//     width: 100px;
//   }
.ProfileUpdate .social-media-accounts {
  .title {
    font-size: 13px;
    font-weight: 600;
  }
}

.ProfileUpdate .social-media-inputs {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #dcdfe6;
  text-align: center;
  margin-top: 10px;
}

.ProfileUpdate .social-media-inputs:focus {
  outline: none;
  border-bottom: 2px solid $secondary-theme-color;
}

.ProfileUpdate .custom-btn {
  width: 100px;
}

.blue {
  .btn-theme-borderd {
    color: $secondary-theme-color;
    border: 1px solid $secondary-theme-color;
  }

  .btn-theme-borderd:hover {
    background: $secondary-theme-color;
    color: #ffff;
    border: 1px solid $secondary-theme-color;
  }
}

@media screen and (max-width: 1283px) {
  .ProfileUpdate {
    padding: 0px 0 50px 0;
  }

  .form-group {
    margin-bottom: 10px;
  }

  .profile-update-container {
    padding: 60px 10px 60px 10px;
  }
}

@media screen and (max-width: 900px) {
  .form-section {
    width: 100%;
    // margin-top: 20px;
  }
}

@media screen and (max-width: 768px) {
  .save-btn-section {
    text-align: center;
  }
}
</style>

<style lang="scss">
.ProfileUpdate {
  .form-section {
    .form {
      box-shadow: none;
      border: none;
    }

    .el-input.is-disabled .el-input__inner {
      color: #818286;
    }
  }

  .stock-widget-dialog {
    width: 500px;
    border-radius: 10px;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      text-align: center;
    }
  }

  .cropper-dialog-outer {
    /* Styles for Dialog and Preview */
    text-align: center;

    .cropper-dialog {
      .el-dialog {
        width: 480px;
        margin-top: 30px !important;
      }
      .el-dialog__body {
        padding-top: 0;
      }
      .el-dialog__header {
        padding: 0;
      }
    }
    .dialog-title {
      text-align: center;
      font-size: 18px;
      margin-bottom: 10px;
    }
    .cropper-modal {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .cropper-preview-wrapper {
      width: 400px;
      height: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #ddd;
      overflow: hidden;
      background-color: #f8f8f8;
    }
    .cropper-preview-wrapper img,
    .cropper-preview-wrapper canvas {
      // max-width: 100%;
      // max-height: 100%;
      // object-fit: contain; /* Ensures image fits within the fixed space */
    }
    .dialog-actions {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .btn {
      padding: 10px 20px;
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
    .btn-primary {
      background-color: #2d2e8d;
      color: white;
    }
    .btn-secondary {
      background-color: #6c757d;
      color: white;
    }
  }

  @media screen and (max-width: 520px) {
    .stock-widget-dialog {
      width: 90%;
    }

    .cropper-dialog-outer {
      .cropper-dialog {
        .el-dialog {
          width: 98%;
          margin-top: 15vh !important;

          .el-dialog__body {
            padding: 0 10px 20px;
          }
        }
        .cropper-preview-wrapper {
          width: 95%;
          height: 95%;
        }
      }
    }
  }
}

.camera-icon i.el-icon-camera {
  font-size: 25px;
  color: #fff;
}
</style>
